export function interviewTasks(rows, date) {
  return rows
    .filter((row) => String(row.date || "").slice(0, 10) === date)
    .map((row) => {
      const name = [row.person?.firstname, row.person?.lastname]
        .filter(Boolean)
        .join(" ");
      return {
        id: `interview-${row._id || `${row.person?._id}-${row.date}-${row.hour}`}`,
        interview: row,
        category: "appointment",
        title: `Entretien avec ${name || "le candidat"}`,
        time: row.hour,
        clientId: row.client?._id || row.client,
        due_date_original: date,
        scheduled_date: date,
        done: false,
      };
    });
}
